<template>
  <v-skeleton-loader class="mx-auto" type="card" v-if="!slot || !slot.id"></v-skeleton-loader>
  <div v-else>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Nội dung học</v-tab>
      <v-tab class="tab-default" :key="2"> Khen thưởng kỷ luật </v-tab>
      <v-tab class="tab-default" :key="3"> Điểm số </v-tab>
      <v-tab class="tab-default" :key="4"> Nhận xét lớp học</v-tab>
      <!-- <v-tab class="tab-default" :key="5"> Điểm danh</v-tab> -->
      <v-tab class="tab-default" :key="5"> Nhắc nhở sau tiết học</v-tab>
    </v-tabs>

    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <LessonTab />
        </v-tab-item>
        <v-tab-item :key="2">
          <ViolationTab />
        </v-tab-item>
        <v-tab-item :key="3">
          <MarkTab />
        </v-tab-item>
        <v-tab-item :key="4">
          <ClassCommentTab />
        </v-tab-item>
        <v-tab-item :key="5">
          <ClassReminderTab />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LessonTab from '@/modules/classNote/teacherSide/LessonTab.vue'
import ViolationTab from '@/modules/classNote/teacherSide/violations/ViolationTab.vue'
import MarkTab from '@/modules/classNote/teacherSide/MarkTab.vue'
import ClassCommentTab from '@/modules/classNote/teacherSide/ClassCommentTab.vue'
import ClassReminderTab from '@/modules/classNote/teacherSide/ClassReminderTab.vue'

export default {
  data() {
    return {
      tab: null
    }
  },
  components: {
    LessonTab,
    ViolationTab,
    MarkTab,
    ClassCommentTab,
    ClassReminderTab
  },
  methods: {},
  computed: { ...mapState('ClassNoteDetail', ['slot']) }
}
</script>

<style></style>
